export default __webpack_public_path__ + "static/media/copyAll.7cfd7adb.svg";